var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{staticClass:"ma-1 mt-1",attrs:{"rounded":"","size":_vm.size || 128}},[_c('img',{attrs:{"src":_vm.getPhoto,"alt":_vm.getTitle,"title":_vm.getTitle}})])}
var staticRenderFns = []

export { render, staticRenderFns }